module.exports = __webpack_public_path__ + "img/14.71cf2730.jpg";